// root_modal_state.svelte.ts

import type { Component, ComponentProps } from "svelte";
import type { ModalProps } from "../utils.svelte";

type StateValue<T> = { value: T; };

function create_root_modal_state() {
   let internal_is_open = $state({ value: false });
   let internal_component: StateValue<Component | null> = $state({ value: null });
   let internal_props: StateValue<ComponentProps<any> | null> = $state({ value: null });
   let internal_modal_props: StateValue<Omit<ModalProps, 'open' | 'children'> | null> = $state({ value: null });
   let internal_modal_type = $state({ value: 'normal' })

   function close() {
      console.log("Closing modal");
      internal_is_open.value = false;
      internal_component.value = null;
      internal_modal_props.value = null;
      internal_modal_type.value = 'normal'
      internal_props.value = null;
   }

   function open<T extends Component<any>>({ component, props, modal_props, modal_type = 'normal' }: { component: T, props: ComponentProps<T>, modal_type?: 'normal' | 'raw', modal_props: Omit<ModalProps, 'open' | 'children'> }) {
      internal_component.value = component as Component;
      internal_props.value = props;
      internal_modal_props.value = modal_props;
      internal_modal_type.value = modal_type
      internal_is_open.value = true;
   }

   async function open_confirm_modal(props: { subtitle?: string; onsuccess: () => any; ondecline?: () => any }) {

      const ConfirmModal = (await import('../components/ConfirmModal.svelte')).default;

      internal_component.value = ConfirmModal as Component;
      internal_props.value = {
         subtitle: props.subtitle,
         onsuccess: () => {
            props.onsuccess();
            close()
         },
         ondecline: () => {
            props.ondecline?.();
            close()
         }
      };
      internal_modal_props.value = { title: 'confirm', };
      internal_is_open.value = true;
   }



   return {
      get is_open() { return internal_is_open.value },
      set is_open(value) {
         if (value === false) close()
         else internal_is_open.value = value
      },

      get component() { return internal_component.value },
      set component(value) { internal_component.value = value },

      get props() { return internal_props.value },
      set props(value) { internal_props.value = value },

      get modal_props() { return internal_modal_props.value },
      set modal_props(value) { internal_modal_props.value = value },
      get modal_type() { return internal_modal_type.value },
      close,
      open_confirm_modal,
      open
   }
}

export const root_modal_state = create_root_modal_state()